import * as React from 'react';
import {PropsWithChildren, useState} from 'react';
import {useCache} from '../../shared-common/hooks/useCache';
import DataService from '../../shared/services/DataService';
import {TeamMemberFilter} from '../../shared-common/types/TeamMemberFilter';
import {JourneyTeamMember} from '../types/JourneyTeamMember';
import {TeamMemberCache} from '../../shared-common/context/TeamMemberCache';
import {isEmpty} from 'lodash-es';

export interface TeamMemberStoreProps {
  employeeId?: string;
}

export const TeamMemberStore = (props: PropsWithChildren<TeamMemberStoreProps>) => {
  const [isProcessing, setIsProcessing] = useState<boolean>();
  const [teamMemberCount, setTeamMemberCount] = useState<number>(0);

  const {clearCache, getValue} = useCache<TeamMemberFilter, JourneyTeamMember[]>(
    async (key: TeamMemberFilter) => {
      setIsProcessing(true);
      try {
        return await DataService.tryLoad<JourneyTeamMember[]>(
          '/engage-reports/load-journey-team', {
            onlyRated: key.onlyRated,
            clientId: key.clientId,
            surveyModelId: key.surveyModelId,
            questionCodes: key.questionCodes,
            employeeId: props.employeeId
          }
        );
      } finally {
        setIsProcessing(false);
      }
    }
  );

  const getTeamMembers = (filter: TeamMemberFilter) => {
    if (filter.onlyRated && isEmpty(filter.questionCodes)) {
      return [];
    }
    const result = getValue(filter);
    if (!filter.onlyRated && result !== undefined) {
      setTeamMemberCount(result.length);
    }
    return result;
  };

  const clearTeamMemberCache = () => {
    clearCache();
  };

  return (
    <TeamMemberCache.Provider
      value={{
        getTeamMembers: getTeamMembers,
        clearTeamMemberCache: clearTeamMemberCache,
        teamMemberCount: teamMemberCount,
        isTeamMemberCacheProcessing: isProcessing
      }}
    >
      {props.children}
    </TeamMemberCache.Provider>
  );
};
